// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sHIh","label":"styles_label__16AWU"};